var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWithdraw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7506 16H7.41724M7.30436 16.3886L4.19113 25.6882C3.94656 26.4188 3.82427 26.7841 3.91203 27.0091C3.98824 27.2044 4.15192 27.3525 4.3539 27.4089C4.58648 27.4738 4.93777 27.3157 5.64035 26.9996L27.9223 16.9727C28.6081 16.6641 28.951 16.5098 29.0569 16.2954C29.149 16.1092 29.149 15.8907 29.0569 15.7045C28.951 15.4901 28.6081 15.3358 27.9223 15.0273L5.63258 4.99693C4.93212 4.68172 4.58189 4.52412 4.34954 4.58877C4.14775 4.64492 3.98409 4.79263 3.90761 4.98762C3.81955 5.21215 3.94053 5.57665 4.1825 6.30566L7.30523 15.714C7.34679 15.8392 7.36757 15.9018 7.37577 15.9658C7.38305 16.0227 7.38297 16.0802 7.37555 16.137C7.36718 16.201 7.34624 16.2635 7.30436 16.3886Z",
    stroke: "url(#paint0_linear_147_6760)",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_147_6760",
    x1: 29.126,
    y1: 27.4233,
    x2: 0.186054,
    y2: 11.1361,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEE10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB900"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWithdraw);
export default __webpack_public_path__ + "static/media/withdraw.8db28f67095bb39d3d92bfe43e213c4f.svg";
export { ForwardRef as ReactComponent };